// extracted by mini-css-extract-plugin
export default {"text":"InfoText_text__aqwhJ","hidden":"InfoText_hidden__CT5yR"};